import api from './api';

export const gamificationService = {
  getProfile: async () => {
    const response = await api.get('/gamification/profile');
    return response;
  },

  getLeaderboard: async () => {
    const response = await api.get('/gamification/leaderboard');
    return response;
  },

  getDefinitions: async () => {
    const response = await api.get('/gamification/definitions');
    return response;
  },
};

export default gamificationService;
